<template>
  <div>
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="bg_default"
          v-bind="attrs"
          v-on="on"
          fab
          depressed
          small
          dark
          @click="$router.go(-1)"
          ><v-icon>mdi-reply</v-icon></v-btn
        >
      </template>
      <span>Back</span>
    </v-tooltip>
    <div class="d-flex justify-center">
      <div class="_60_w mt-3">
        <title-page title="Create Section" class="mb-3" />
        <v-card color="rounded_max mb-3" elevation="1">
          <div
            :class="` _100pxh d-flex align-end justify-end`"
            :style="`background:${selectedColor};`"
          >
            <v-menu v-model="colorMenu" bottom :nudge-bottom="55" elevation="0">
              <template v-slot:activator="{ on, attrs }">
                <div
                  v-bind="attrs"
                  v-on="on"
                  class="pa-3 d-flex align-center color_picker"
                >
                  <h3 class="white--text mr-2">Pick Color</h3>
                  <div class="temp_color">
                    <div
                      class="theme"
                      :style="`background:${selectedColor};`"
                    ></div>
                  </div>
                </div>
              </template>
              <v-card class="popup_radius" width="250px" outlined elevation="0">
                <v-row no-gutters>
                  <v-col
                    cols="3"
                    v-for="(item, i) in listColor"
                    :key="`color_${i}`"
                  >
                    <div class="pa-2">
                      <div class="temp_color_item pa-1">
                        <div
                          @click="selectedColor = item"
                          class="color_item"
                          :style="`background:${item};`"
                        ></div>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-menu>
          </div>
          <div class="pa-3">
            <v-row no-gutters>
              <v-col cols="12" md="12">
                <div class="pa-2">
                  <p class="default_txt">Title</p>
                  <v-text-field
                    dense
                    v-model="form.title"
                    placeholder="Type Here"
                    hide-details
                    color="green"
                  ></v-text-field>
                </div>
              </v-col>

              <v-col cols="12" md="12">
                <div class="pa-2">
                  <p class="default_txt">Description</p>
                  <v-textarea
                    v-model="form.description"
                    dense
                    placeholder="Type Here"
                    hide-details
                    rows="3"
                    auto-grow
                    color="green"
                  ></v-textarea>
                </div>
              </v-col>
              <v-col cols="12" md="12">
                <div class="pa-2 d-flex">
                  <v-checkbox
                    v-model="form.param_end"
                    label="Last Section"
                  ></v-checkbox>
                </div>
              </v-col>
            </v-row>
          </div>
          <v-overlay :absolute="true" color="white" :value="loading">
          </v-overlay>
        </v-card>

        <v-card color="rounded_max mb-3" elevation="1">
          <div class="pa-3">
            <div class="pt-2 d-flex align-center">
              <v-icon class="mr-2">mdi-calendar-month-outline</v-icon>
              <h3>Start</h3>
            </div>
            <v-row no-gutters>
              <v-col cols="12" md="7">
                <div class="pa-2">
                  <p class="default_txt">Start Date</p>
                  <v-menu
                    v-model="calendar1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="form.start_date"
                        placeholder="Click here"
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        hide-details
                        dense
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="form.start_date"
                      @input="calendar1 = false"
                      :min="$date().format('YYYY-MM-DD')"
                    ></v-date-picker>
                  </v-menu>
                </div>
              </v-col>

              <v-col cols="12" md="5">
                <div class="pa-2">
                  <p class="default_txt">Start Time</p>
                  <v-menu
                    ref="menu1"
                    v-model="time1"
                    :close-on-content-click="false"
                    :return-value.sync="form.start_time"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="form.start_time"
                        placeholder="Click Here"
                        append-icon="mdi-clock-time-four-outline"
                        readonly
                        v-bind="attrs"
                        dense
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="time1"
                      v-model="form.start_time"
                      full-width
                      @click:minute="$refs.menu1.save(form.start_time)"
                    ></v-time-picker>
                  </v-menu>
                </div>
              </v-col>
            </v-row>

            <div class="pt-2 d-flex align-center">
              <v-icon class="mr-2">mdi-calendar-month-outline</v-icon>
              <h3>End</h3>
            </div>
            <v-row no-gutters>
              <v-col cols="12" md="7">
                <div class="pa-2">
                  <p class="default_txt">End Date</p>
                  <v-menu
                    v-model="calendar2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="form.end_date"
                        :disabled="!form.start_date"
                        placeholder="Click here"
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        hide-details
                        dense
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="form.end_date"
                      @input="calendar2 = false"
                      :min="$date(form.start_date).format('YYYY-MM-DD')"
                    ></v-date-picker>
                  </v-menu>
                </div>
              </v-col>

              <v-col cols="12" md="5">
                <div class="pa-2">
                  <p class="default_txt">End Time</p>
                  <v-menu
                    ref="menu2"
                    v-model="time2"
                    :close-on-content-click="false"
                    :return-value.sync="form.end_time"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="form.end_time"
                        :disabled="!form.start_date"
                        placeholder="Click Here"
                        append-icon="mdi-clock-time-four-outline"
                        readonly
                        v-bind="attrs"
                        dense
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="time2"
                      v-model="form.end_time"
                      full-width
                      @click:minute="$refs.menu2.save(form.end_time)"
                    ></v-time-picker>
                  </v-menu>
                </div>
              </v-col>
            </v-row>
          </div>
          <v-overlay :absolute="true" color="white" :value="loading">
          </v-overlay>
        </v-card>
        <div class="d-flex justify-end mb-5">
          <v-btn
            v-if="!loading"
            class="bg_default text-capitalize rounded-lg"
            depressed
            dark
            @click="createData"
            >Create</v-btn
          >
          <v-btn
            v-if="loading"
            class="bg_default text-capitalize rounded-lg"
            depressed
            dark
            >Creating...</v-btn
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import titlePage from "../../../../components/atom/titlePage.vue";
export default {
  name: "createCourse",
  components: { titlePage },
  data() {
    return {
      loading: false,
      colorMenu: false,
      categories: [
        { txt: "Lead Self", val: 1 },
        { txt: "Lead Others", val: 2 },
        { txt: "Professional Preparation", val: 3 },
      ],
      calendar1: false,
      calendar2: false,
      time1: false,
      selectedColor: "#53AD71",
      time2: false,
      form: {
        title: "",
        category: 1,
        description: "",
        start_date: "",
        end_date: "",
        start_time: "00:00",
        end_time: "23:59",
        param_end: false,
      },
      listColor: [
        "#53AD71",
        "#F0AC91",
        "#36474F",
        "#4381F1",
        "#59B6AD",
        "#F2C021",
        "#E36154",
        "#775BA6",
        "#D92B60",
        "#863A95",
        "#62C3F8",
        "#871751",
      ],
    };
  },
  methods: {
    createData() {
      this.loading = true;
      let start = `${this.form.start_date} ${this.form.start_time}`;
      let end = `${this.form.end_date} ${this.form.end_time}`;

      let body = {
        course_id: this.$route.params.idCourse,
        title: this.form.title,
        description: this.form.description,
        start_section: this.$date(start).unix(),
        end_section: this.$date(end).unix(),
        color: this.selectedColor,
        param_end: this.form.param_end ? 1 : 0,
      };
      let data = {
        path: `manage/course/section`,
        body: body,
      };
      this.$store
        .dispatch("course/postApi", data)
        .then((data) => {
          this.$router.push(`/course/inclass/${this.$route.params.idCourse}`);
          this.$store.dispatch("notify", {
            msg: data.message,
            type: "success",
          });
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.temp_color {
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  height: 20px;
  width: 20px;
  border-radius: 50%;
}
.theme {
  height: 12px;
  width: 12px;
  border-radius: 3px;
}
.color_picker {
  cursor: pointer;
}

.temp_color_item {
  background: #fff;
  height: 30px;
  /* width: 30px; */
}
.color_item {
  height: 100%;
  width: 100%;
  cursor: pointer;
}
</style>
